import Wrapper from "@/layout/wrapper/Wrapper";
import styled from "@emotion/styled";
import React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid } from "@mui/material";
import InputField from "@/components/InputField/InputField";
import assest from "@/json/assest";
import CustomButton from "@/ui/Buttons/CustomButton";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ContactFormResponse,
  contactForm,
  contactFormDataPost,
} from "@/api/functions/cms.api";
import { useMutation } from "react-query";
import useNotiStack from "@/hooks/useNotistack";
import { NextSeo } from "next-seo";

const ContactWrap = styled(Box)`
  h1 {
    color: var(--white);
    margin-bottom: 50px;
    text-transform: uppercase;
    @media (max-width: 767px) {
      font-size: 40px;
      margin-bottom: 30px;
    }
    @media (max-width: 479px) {
      font-size: 35px;
    }
  }
  .submit_btn {
    text-align: center;
    button {
      min-width: 200px;
      padding: 19px 22px;
      @media (max-width: 479px) {
        padding: 16px 22px;
        min-width: 150px;
      }
    }
  }
  .contact_form_wrap {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 15px;
    padding: 55px 70px;
    @media (max-width: 899px) {
      padding: 42px 40px;
    }
    @media (max-width: 479px) {
      padding: 32px 20px;
    }
  }
  .textarea_cnts {
    .MuiFormControl-root {
      .MuiInputBase-root {
        textarea {
          height: 179px !important;
          box-sizing: border-box;
          @media (max-width: 899px) {
            height: 150px !important;
          }
        }
      }
    }
  }
  .submit_btn {
    margin-top: 30px;
    @media (max-width: 479px) {
      margin-top: 20px;
    }
  }
`;
// const phoneMatch = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
const schema = Yup.object({
  name: Yup.string().min(2).required(),
  email: Yup.string().email().required(),
  message: Yup.string().required(),
  // phone: Yup.string().matches(phoneMatch, "phone number is invalid").required(),
  // address: Yup.string().required()
});
export default function index() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    control,
    reset,
  } = useForm<contactForm>({ resolver: yupResolver(schema) });
  const { mutate, isLoading } = useMutation(contactFormDataPost);
  const { toastSuccess, toastError } = useNotiStack();
  const contactSubmit = (data: contactForm) => {
    console.log(data);
    let d = {
      ...data,
      type: "Web",
    };
    mutate(d, {
      onSuccess: (res: ContactFormResponse | any) => {
        if (res?.status === 200) {
          toastSuccess(res?.message);
          // reset({name:"", email:"", address:"", phone:"", message:""})
          reset({ name: "", email: "", message: "" });
        } else {
          toastError("sorry!!! couldn't add the contact");
        }
        console.log(res);
      },
      onError: () => {
        toastError("something is wrong!");
      },
    });
  };
  console.log(watch("name"));
  console.log(errors);
  return (
    <Wrapper>
      <NextSeo noindex={false} nofollow={false} />
      <ContactWrap className="contact_wrap cmn_gap">
        <Container fixed>
          <Box className="contact_outr">
            <Typography variant="h1" color="initial">
              Contact us
            </Typography>
            <form>
              <Box className="contact_form_wrap">
                <Grid
                  container
                  rowSpacing={{ xs: 1, lg: 2 }}
                  columnSpacing={{ xs: 1, md: 4 }}
                >
                  <Grid item lg={6} xs={12}>
                    <Controller
                      control={control}
                      name="name"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <InputField
                          icon={assest.icon1}
                          placeholder="Enter your name"
                          type="text"
                          value={value}
                          onChange={onChange}
                          // inputRef={ref}
                          name={name}
                          onBlur={onBlur}
                        />
                      )}
                    />
                    {errors?.name && (
                      <p style={{ color: "red", marginLeft: "18px" }}>
                        {errors?.name?.message}
                      </p>
                    )}
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    {/* <InputField
                      placeholder="Enter Your Email"
                      icon={assest.icon2}
                      {...register("email")}
                    /> */}
                    <Controller
                      control={control}
                      name="email"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <InputField
                          icon={assest.icon2}
                          placeholder="Enter your email"
                          type="email"
                          value={value}
                          onChange={onChange}
                          // inputRef={ref}
                          name={name}
                          onBlur={onBlur}
                        />
                      )}
                    />
                    {errors?.email && (
                      <p style={{ color: "red", marginLeft: "18px" }}>
                        {errors?.email?.message}
                      </p>
                    )}
                  </Grid>
                  {/* <Grid item lg={6} xs={12}>
                   
                    <Controller
                      control={control}
                      name="address"
                      render={({field:{onChange, onBlur, name, value, ref}})=>{return ( 
                        <InputField 
                          icon={assest.icon3}
                          placeholder="Enter your address"
                          type="text"
                          name={name}
                          value={value}
                          onChange={onChange}
                          onBlur={onBlur}
                        />)}
                      }
                     />
                     {errors?.address && <p style={{color:"red", marginLeft:"18px"}}>{errors?.address?.message}</p>}
                  </Grid> */}
                  {/* <Grid item lg={6} xs={12}>
                    
                    <Controller
                      control={control}
                      name="phone"
                      render={({field:{onChange, onBlur, name, value, ref}})=>( 
                        <InputField 
                          icon={assest.icon4}
                          placeholder="Enter your phone"
                          type="tel"
                          name={name}
                          value={value}
                          onChange={onChange}
                          onBlur={onBlur}
                        />)
                      }
                     />
                     {errors?.phone && <p style={{color:"red", marginLeft:"18px"}}>{errors?.phone?.message}</p>}
                  </Grid> */}
                  <Grid item lg={12} xs={12} className="textarea_cnts">
                    {/* <InputField
                      placeholder="Message"
                      icon=""
                      isIcon={false}
                      isTextArea
                    /> */}
                    <Controller
                      control={control}
                      name="message"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <InputField
                          icon=""
                          isIcon={false}
                          isTextArea={true}
                          placeholder="Enter your message"
                          type="textarea"
                          value={value}
                          onChange={onChange}
                          // inputRef={ref}
                          name={name}
                          onBlur={onBlur}
                        />
                      )}
                    />
                    {errors?.message && (
                      <p style={{ color: "red", marginLeft: "18px" }}>
                        {errors?.message?.message}
                      </p>
                    )}
                  </Grid>
                  <Grid item lg={12} xs={12}>
                    <Box className="submit_btn">
                      <CustomButton
                        type="button"
                        loading={isLoading}
                        onClick={handleSubmit(contactSubmit)}
                      >
                        <Typography variant="caption">submit</Typography>
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </form>
          </Box>
        </Container>
      </ContactWrap>
    </Wrapper>
  );
}
